"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parseApiRoot = (config) => {
    let roots;
    try {
        roots = JSON.parse(config);
        if (typeof roots === "string") {
            roots = {
                "*": roots
            };
        }
    }
    catch (e) {
        //    JSON parse error, treat config as a simple string
        roots = {
            "*": config
        };
    }
    return roots;
};
exports.parseApiRoot = parseApiRoot;
const lookupApiRoot = (config, serviceName) => {
    const service = serviceName.split("/")[0];
    return config[service] || config["*"];
};
exports.lookupApiRoot = lookupApiRoot;
//# sourceMappingURL=base.js.map